import {IonHeader, IonToolbar, IonButtons, IonButton, IonIcon} from '@ionic/react';
import {personCircleOutline, logOutOutline} from 'ionicons/icons';
import {useAuth} from '@/hooks/useAuth';
import {useState} from 'react';
import './AppHeader.css';

export const AppHeader = () => {
    const {user, logout} = useAuth();
    const [showMenu, setShowMenu] = useState(false);

    return (
        <>
            <IonHeader className="ion-no-border">
                <IonToolbar style={{
                    '--background': 'var(--color-stone-1000)',
                } as React.CSSProperties}>
                    <div slot="start" className="flex items-center gap-3 pl-4">
                        <img
                            src="/assets/logos/saplab-logo-dark.svg"
                            alt="SapLab"
                            className="h-17"
                        />
                    </div>

                    <IonButtons slot="end" className="pr-2">
                        <IonButton id="user-menu-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowMenu(!showMenu);
                            }}
                        >
                            <IonIcon className="text-color-maple-500"
                                slot="icon-only"
                                icon={personCircleOutline}
                            />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            {showMenu && (
                <>
                    <div
                        id="dropdown-menu-backdrop"
                        onClick={() => setShowMenu(false)}
                    />

                    <div
                        onClick={(e) => e.stopPropagation()}
                        id="dropdown-menu-user"
                    >
                        <div id="dropdown-menu-content">
                            <div id="user-info">
                                <span id="user-name">
                                    {user?.first_name} {user?.last_name}
                                </span>
                            </div>

                            <div className="dropdown-menu-divider"></div>

                            <button
                                onClick={() => {
                                    setShowMenu(false);
                                    logout();
                                }}
                                id="logout-button"
                            >
                                <IonIcon icon={logOutOutline} id="icon-logout"/>
                                <span>Déconnexion</span>
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};